import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.css"]
})
export class LandingComponent implements OnInit {
  fplPercent = "";
  familyIncome = 0;
  familySize = 1;

  constructor() {}

  ngOnInit() {}

  calculate_fpl() {
    let income = this.familyIncome;
    let persons = this.familySize;
    // This figure will need to be updated each year

    // that the FPL for each additional person changes.

    let fpl_addperson = 4420;

    // This array will need to be updated each year

    // that the FPL changes for the various family sizes.

    let fpl_array = [
      12490, // family of 1

      16910, // family of 2

      21330, // family of 3

      25750, // family of 4

      30170, // etc.

      34590,

      39010,

      43430,

      47850,

      52270
    ];

    let fpl_val = fpl_array[persons - 1];

    if (persons > 10) {
      fpl_val = fpl_array[9] + (persons - 10) * fpl_addperson;
    }

    this.fplPercent = (((income * 12) / fpl_val) * 100).toFixed(2);
    this.fplPercent += "% FPL";

    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts